<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">ALTERAR VALOR</h3>
  </div>
  <div class="modal-body">
    <form [formGroup]="alterarValorForm" class="forms modal-alterar-valor">
      <div class="form-group">
        <span class="icon dinheiro"></span>

        <div class="inputs">
          <div style="display: inline-flex">
            <label for="valorFinanciamento">Valor Solicitado</label>
            <div style="margin-top: -3px">
              <saiba-mais
                  [isPopoverOnHover]="true"
                  [isPositionStatic]="true"
                  [isSmall]="true"
                  [texto]="'Informe o valor do financiamento solicitado.'">
              </saiba-mais>
            </div>
          </div>

          <input
            class="form-control"
            type="text"
            placeholder="R$ 00.000,00"
            [maxLength]="15"
            [minLength]="1"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            formControlName="valorFinanciamento"
            name="valorFinanciamento"
            mask-money
            inputmode="numeric"
            [prefix]="'R$'"
            appMoedaValidator
            appOnlyNumberRestrictive
            valorMinimo="200">
        </div>
      </div>

      <div class="destak" *ngIf="proposta?.contratoRepique">
        <div class="form-group">
          <span class="icon divida-contrato"></span>
          <div class="inputs">
            <div style="display: inline-flex">
              <label for="tabela">Valor da Dívida</label>
              <div style="margin-top: -3px">
                <saiba-mais
                    [isPopoverOnHover]="true"
                    [isPositionStatic]="true"
                    [isSmall]="true"
                    [texto]="'Valor a ser quitado do contrato anterior.'">
                </saiba-mais>
              </div>
            </div>
            <input disabled [value]="valorDivida| currency:'BRL':'symbol':'1.2-2'">
          </div>
        </div>
        <div class="form-group">
          <span class="icon credito"></span>
          <div class="inputs">
            <div style="display: inline-flex">
              <label for="tabela">Valor Liberado</label>
              <div style="margin-top: -3px">
                <saiba-mais
                    [isPopoverOnHover]="true"
                    [isPositionStatic]="true"
                    [isSmall]="true"
                    [texto]="'Valor que o cliente irá receber após quitação do contrato anterior.'">
                </saiba-mais>
              </div>
            </div>
            <input disabled [value]="valorLiberado | currency:'BRL':'symbol':'1.2-2'">
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="marginT30 form-group tab-buttons">
        <a class="bt-back btn btn-border-orange pull-left" (click)="close()"> Fechar</a>
        <button
          type="button"
          class="bt-go btn btn-full-orange pull-right"
          [disabled]="!formValid"
          (click)="save()">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
